export default {
    mobileWebDomain: 'https://h5.scrm.miniso.com',
}
